import utils from "../index";
export default{

    getWaitDate: function(minute){
        let remindDate = new Date("2000-01-01 00:00:00");
        remindDate = new Date(remindDate.getTime() + minute * 60 * 1000);
        remindDate = Solar.fromDate(remindDate);
        const dateString = remindDate.getYear() + "年" + remindDate.getMonth() + "月" + remindDate.getDay() + "日";
        const timeString = remindDate.toYmd().slice(11,16);
        return dateString + " " + timeString;
    },
    getAllDate: function(minute){
        const dayNum = Math.floor(minute / 1440);
        const minuteNum = minute % 1440;
        const hours = Math.floor(minuteNum / 60);
        const minutes = minuteNum % 60;
        let text;
        if(dayNum === 0){
            text = "当天 ";
        }else{
            text = "提前" + dayNum + "天 ";
        }
        return text + utils.addZero(hours) + ":" + utils.addZero(minutes);
    },
    getTimeDate: function(minute){
        const dayNum = Math.floor(minute / 1440);
        const minuteNum = minute % 1440;
        const hours = Math.floor(minuteNum / 60);
        const minutes = minuteNum % 60;
        let text;

        if(minute === 0){
            text = "准时提醒"
        }else{
            text = "提前";
            if(dayNum > 0){
                text = text + dayNum + "天";
            }
            if(hours > 0){
                text = text + hours + "小时";
            }
            if(minutes > 0){
                text = text + minutes + "分钟";
            }
        }
        return text
    },
}